import { render, staticRenderFns } from "./BlogHeader.vue?vue&type=template&id=12bb8b24&scoped=true&"
import script from "./BlogHeader.vue?vue&type=script&lang=js&"
export * from "./BlogHeader.vue?vue&type=script&lang=js&"
import style0 from "./BlogHeader.vue?vue&type=style&index=0&id=12bb8b24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bb8b24",
  null
  
)

export default component.exports